// extracted by mini-css-extract-plugin
export default {"root":"cmp-CartTrigger__cartTrigger__root cmp-components__clickable__root","icon":"cmp-CartTrigger__cartTrigger__icon"};